'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, Fetchable } from '@morpho-org/blue-sdk';
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import type { VaultV1ActionPanelData } from '@/components/VaultPage/VaultV1/VaultSimpleActionPanel/vaultV1ActionPanelData';
import VaultTransactionInfoCardInner from '@/components/common/VaultTransactionInfoCard/VaultTransactionInfoCardInner';
import { getParsedValue } from '@/helpers/formatters';
import { useVaultV1Apy } from '@/hooks/useVaultV1Apy';
interface VaultV1TransactionInfoCardProps {
  vaultData: VaultV1ActionPanelData;
  vaultAddress: Address;
  vaultAsset: InterfaceToken;
  initialPosition: Fetchable<bigint>;
  finalPosition: Fetchable<bigint>;
}

/**
 * Position-manager summary card for V1 vaults. Mirrors `VaultV2TransactionInfoCard` so the V1
 * and V2 position managers render the same card surface and layout (vault header with curators,
 * network / position / APY / exposure rows).
 */
const VaultV1TransactionInfoCard = t0 => {
  const $ = _c(24);
  const {
    vaultData,
    vaultAddress,
    vaultAsset,
    initialPosition,
    finalPosition
  } = t0;
  const {
    rewards
  } = vaultData;
  let t1;
  if ($[0] !== rewards || $[1] !== vaultAddress || $[2] !== vaultData.asset || $[3] !== vaultData.state) {
    t1 = {
      vaultV1: {
        address: vaultAddress,
        asset: vaultData.asset,
        state: vaultData.state,
        rewards
      }
    };
    $[0] = rewards;
    $[1] = vaultAddress;
    $[2] = vaultData.asset;
    $[3] = vaultData.state;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    apy,
    netApy,
    performanceFee,
    points
  } = useVaultV1Apy(t1);
  const t2 = vaultData.state.allocation;
  const t3 = vaultData.state.curators;
  const t4 = vaultData.warnings;
  const t5 = vaultData.name;
  let t6;
  if ($[5] !== vaultData.state.totalAssetsUsd) {
    t6 = getParsedValue(vaultData.state.totalAssetsUsd, safeParseNumber);
    $[5] = vaultData.state.totalAssetsUsd;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== apy || $[8] !== netApy || $[9] !== performanceFee || $[10] !== points || $[11] !== rewards || $[12] !== t6 || $[13] !== vaultAddress || $[14] !== vaultAsset || $[15] !== vaultData.name || $[16] !== vaultData.state.allocation || $[17] !== vaultData.state.curators || $[18] !== vaultData.warnings) {
    t7 = {
      apy,
      netApy,
      performanceFee,
      allocation: t2,
      rewards,
      points,
      address: vaultAddress,
      curators: t3,
      warnings: t4,
      name: t5,
      asset: vaultAsset,
      totalAssetsUsd: t6
    };
    $[7] = apy;
    $[8] = netApy;
    $[9] = performanceFee;
    $[10] = points;
    $[11] = rewards;
    $[12] = t6;
    $[13] = vaultAddress;
    $[14] = vaultAsset;
    $[15] = vaultData.name;
    $[16] = vaultData.state.allocation;
    $[17] = vaultData.state.curators;
    $[18] = vaultData.warnings;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== finalPosition || $[21] !== initialPosition || $[22] !== t7) {
    t8 = <VaultTransactionInfoCardInner vault={t7} initialPosition={initialPosition} finalPosition={finalPosition} />;
    $[20] = finalPosition;
    $[21] = initialPosition;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default VaultV1TransactionInfoCard;